<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
      <v-btn icon v-if="$route.path != '/dashboard' && $route.path != '/'" to="/dashboard"
        ><v-icon>mdi-arrow-left</v-icon></v-btn
      >
      <h3>Chainers</h3>
      <v-btn icon to="/" class="mx-2"><v-icon>mdi-currency-btc</v-icon></v-btn>
      <v-btn icon to="/news" class="mr-2"><v-icon>mdi-newspaper-variant-multiple</v-icon></v-btn>
      <!-- <v-btn icon to="/pay" class="mr-2"><v-icon>mdi-wallet</v-icon></v-btn> -->
      <v-spacer />
      <!-- <v-avatar>
        <v-img src="https://via.placeholder.com/150" />
      </v-avatar> -->
      <!-- <v-btn icon to="/profile" class="mr-2" v-if="isLoggedIn"><v-icon>mdi-account</v-icon></v-btn> -->
      <v-btn icon to="/about" class="mr-2"><v-icon>mdi-help</v-icon></v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { Capacitor } from '@capacitor/core';

export default {
  name: "App",
  computed: {
    ...mapState(["isLoggedIn", "isPro", "id_user"]),
  },
  data: () => ({
    Capacitor:Capacitor
  }),
  methods: {
    unlockApp(event) {
      console.log("event", event);
      if (event.state == "approved") {
        this.$store.dispatch("unlockApp", true);
      }
    },
    checkStoreState() {
      this.$iapstore.register([
        {
          id: "proyearly",
          type: this.$iapstore.PAID_SUBSCRIPTION,
        },
        {
          id: "promonthly",
          type: this.$iapstore.PAID_SUBSCRIPTION,
        },
      ]);

      this.$iapstore.when("proyearly").updated(this.unlockApp); // match a specific product
      this.$iapstore.when("promonthly").updated(this.unlockApp); // match a specific product
      this.$iapstore.when("proyearly").owned(this.unlockApp); // match a specific product
      this.$iapstore.when("promonthly").owned(this.unlockApp); // match a specific product

      // Show errors for 10 seconds.
      this.$iapstore.error(function (error) {
        console.log(error);
      });

      // Called when any subscription product is updated
      this.$iapstore.when("subscription").updated(function () {
        const product1 = this.$iapstore.get("proyearly") || {};
        const product2 = this.$iapstore.get("promonthly") || {};
        console.log("yearly : ", product1);
        console.log("monthly : ", product2);
      });

      // Later, we will add our events handlers here

      // Load informations about products and purchases
      this.$iapstore.refresh();
    },
  },
  mounted() {
    console.log(this.$route);
    console.log("env ? ", process.env.NODE_ENV);
    if (process.env.NODE_ENV == "development") {
      this.$store.dispatch("unlockApp", true);
    }
    if(this.id_user && this.Capacitor.getPlatform() == "web")
    {
      this.$axios.get('/user/' + this.id_user).then(res=>{
          this.$store.dispatch("unlockApp", res.data.ispro);
      }).catch(()=>{
        this.$store.dispatch("unlockApp", false)
      });
    }
    
    this.checkStoreState();
  },
};
</script>

<style lang="scss">
header.v-sheet.theme--dark.v-toolbar.v-app-bar.v-app-bar--fixed.primary {
  border-radius: 30px;
  transform: translateY(30px) !important;
  margin: 10px;
  top: inherit;
  bottom: 3em;
}

.v-application--wrap {
  padding-top: 2em !important;
  padding-bottom: 6em !important;
}

main.v-main {
  padding: 0px !important;
}

@import url("https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400;500;600;700;800;900&display=swap");

$body-font-family: "Maven Pro";
$title-font: "Maven Pro";
.v-application {
  font-family: $body-font-family, sans-serif !important;
  .title {
    // To pin point specific classes of some components
    font-family: $title-font, sans-serif !important;
  }
}
</style>
